import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Clock, AlertTriangle, CheckCircle2, XCircle, ClipboardCheck } from "lucide-react";
import ReviewsTable from "./ReviewsTable";

export default function ReviewerDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/technical-reviewer/dashboard").then((r) => setData(r.data)).catch(() => toast.error("Failed to load dashboard"));
  }, []);

  if (!data) return <div className="flex h-64 items-center justify-center" data-testid="reviewer-dashboard-loading"><Clock className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const { kpis, pending_reviews } = data;
  const cards = [
    { label: "Pending Reviews", value: kpis.pending, icon: Clock, testid: "kpi-pending-reviews" },
    { label: "Overdue", value: kpis.overdue, icon: AlertTriangle, testid: "kpi-overdue-reviews", red: true },
    { label: "Approved", value: kpis.approved, icon: CheckCircle2, testid: "kpi-approved-reviews" },
    { label: "Rejected", value: kpis.rejected, icon: XCircle, testid: "kpi-rejected-reviews" },
    { label: "Total Reviews", value: kpis.total, icon: ClipboardCheck, testid: "kpi-total-reviews" },
  ];

  return (
    <div data-testid="reviewer-dashboard" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight" data-testid="reviewer-greeting">Welcome, {user?.name}</h1>
        <p className="text-sm font-medium text-slate-600" data-testid="reviewer-org">{data.org_name}</p>
        <p className="text-sm text-muted-foreground">Review and evaluate technical quotations assigned to you.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {cards.map((c) => (
          <div key={c.label} className="rounded-lg border bg-card p-4" data-testid={c.testid}>
            <div className="flex items-center justify-between">
              <p className="text-xs uppercase tracking-wide text-muted-foreground">{c.label}</p>
              <c.icon className={`h-4 w-4 ${c.red ? "text-[#DC2626]" : "text-slate-400"}`} />
            </div>
            <p className={`mt-2 font-heading text-2xl font-semibold ${c.red && c.value > 0 ? "text-[#DC2626]" : ""}`}>{c.value}</p>
          </div>
        ))}
      </div>

      <div>
        <h2 className="mb-3 font-heading text-base font-semibold">Pending Technical Reviews</h2>
        <ReviewsTable reviews={pending_reviews} />
      </div>
    </div>
  );
}
